import Preview from "./index.vue";
var obj = {};
let instance;

obj.install = function(Vue) {
  /**
   * 图片预览
   * @param {Array} imgList 图片完整路径数组
   * @param {Number} idx 当前预览图片的索引
   */
  const ImgPreview = function(imgList = [], idx = 0) {
    const PreviewConstructor = Vue.extend(Preview);
    instance = new PreviewConstructor();

    instance.$mount(document.createElement("div"));
    document.body.appendChild(instance.$el);

    instance.imgList = imgList;
    instance.idx = idx;
    instance.Open()
  };

  Vue.prototype.$preview = ImgPreview;
};
export default obj;
